import React from "react";
import { isTablet, isMobile } from "react-device-detect";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const FeedPosts = ({
  designTokens,
  isMobileView = false,
}: {
  designTokens?: any;
  isMobileView?: boolean;
}) => {
  const isDefaultTheme =
    !designTokens?.tertiaryColor || designTokens?.tertiaryColor === "#e6e7eb";

  function SkeletonStatBox() {
    return (
      <div
        className="skeleton-feed-tile"
        style={{
          border:
            designTokens?.tertiaryColor &&
            designTokens?.tertiaryColor !== "#e6e7eb"
              ? `1px solid ${designTokens?.tertiaryColor}`
              : "none",
        }}
      >
        <Skeleton
          className="card-skeleton"
          containerClassName="skeleton-feed-tile__media"
          width="100%"
          height="100%"
          baseColor={isDefaultTheme ? "#f1f1f1" : "transparent"}
          highlightColor={isDefaultTheme ? "#f1f1f1" : "transparent"}
        />
      </div>
    );
  }

  return (
    <div className="skeleton-content">
      <div
        className={`skeleton-feed${isMobileView ? " skeleton-feed-mobile" : ""}`}
      >
        {Array<null>(isTablet || isMobile || isMobileView ? 6 : 10)
          .fill(null)
          .map((_, index) => (
            <SkeletonStatBox key={index} />
          ))}
      </div>
    </div>
  );
};

export default FeedPosts;
